import { IconTypes } from "../Icons";

export default function GiftCardIcon({
  color = "#ffffff",
  fontSize = "1.6rem",
  rotate = 0,
  className = "",
}: IconTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      style={{
        width: "1em",
        height: "1em",
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
    >
      <path
        d="M185 125.545V83.394L193 103.152C196.485 111.667 192.909 121.273 185 125.545Z"
        fill="#E5E8FF"
      />
      <path
        d="M164.515 32.9091L169.151 44.3333C168.515 44.2727 167.848 44.2424 167.151 44.2424H89.1211L141.242 23.0909C150.394 19.3636 160.818 23.7879 164.515 32.9091Z"
        fill="#E5E8FF"
      />
      <path
        d="M32.8174 155.758H110.848L58.7264 176.909C49.5749 180.636 39.181 176.212 35.484 167.061L30.8477 155.636C31.484 155.727 32.1507 155.758 32.8174 155.758Z"
        fill="#E5E8FF"
      />
      <path
        d="M185.03 62.0909V137.909C185.03 147.758 177.03 155.758 167.182 155.758H32.8485C23 155.758 15 147.758 15 137.909V62.0909C15 52.2424 23 44.2424 32.8485 44.2424H167.182C177.03 44.2424 185.03 52.2424 185.03 62.0909Z"
        fill="#007AFD"
      />
      <path
        d="M14.9691 74.4545V116.606L6.96911 96.8485C3.51457 88.3333 7.09032 78.7273 14.9691 74.4545Z"
        fill="#E5E8FF"
      />
      <path
        d="M67.5137 44.2424H90.0591V88.5152H67.5137V44.2424Z"
        fill="#E5E8FF"
      />
      <path
        d="M67.5137 111.061H90.0591V155.333H67.5137V111.061Z"
        fill="#E5E8FF"
      />
      <path
        d="M14.9688 88.4849H184.999V111.03H14.9688V88.4849Z"
        fill="#FFD24F"
      />
      <path
        d="M67.5137 44.2424H90.0591V88.5152H67.5137V44.2424Z"
        fill="#FFD24F"
      />
      <path
        d="M67.5137 111.061H90.0591V155.333H67.5137V111.061Z"
        fill="#FFD24F"
      />
      <path
        d="M132.637 59.7576H168.546V70.6667H132.637V59.7576Z"
        fill="#E5E8FF"
      />
      <path
        d="M83.3942 88.9394L109.364 116.697C109.849 117.242 109.364 118.091 108.667 117.939L97.2427 115.515C96.7275 115.394 96.273 115.848 96.3336 116.364L98.0002 127.909C98.0911 128.636 97.2124 129.061 96.7275 128.515L70.7578 100.758L83.3942 88.9394Z"
        fill="white"
      />
      <path
        d="M80.4837 99.6061V137.606C80.4837 138.333 79.5443 138.636 79.1201 138.03L72.4231 128.455C72.1201 128.03 71.4837 128.03 71.211 128.455L64.514 138.03C64.0898 138.636 63.1504 138.333 63.1504 137.606V99.6061H80.4837Z"
        fill="white"
      />
      <path
        d="M112.909 105.121C101.303 108.182 81.5758 103.364 78.5152 91.7576C78.0607 90.0909 78.0001 88.3636 78.2728 86.6364C78.2425 87.303 78.394 87.9091 78.7273 88.3939C81.9698 93.3636 102 86.0909 108.394 81.9394C114.273 78.1212 116.939 71.6364 114.879 66.7273C116.546 69.697 118 74.2727 120 80.8182C123.515 92.2424 124.485 102.061 112.909 105.121Z"
        fill="#04B5A4"
      />
      <path
        d="M108.394 81.9091C102 86.0606 81.9394 93.3333 78.7273 88.3636C75.5152 83.3939 90.3334 68.0909 96.7576 63.9394C103.182 59.7879 110.97 60.4546 114.182 65.3939C117.394 70.3636 114.818 77.7576 108.394 81.9091Z"
        fill="#242B2B"
      />
      <path
        d="M45.3327 122.97C56.9387 119.909 71.6963 105.97 68.6357 94.3636C68.1812 92.697 67.3933 91.1515 66.3327 89.7879C66.666 90.3636 66.8478 90.9394 66.8175 91.5152C66.4539 97.4242 45.4539 101 37.8175 100.576C30.8175 100.152 25.3024 95.8182 24.666 90.5454C24.666 93.9697 25.6963 98.6364 27.1812 105.303C29.7569 117.03 33.7266 126.03 45.3327 122.97Z"
        fill="#04B5A4"
      />
      <path
        d="M37.7871 100.545C45.4235 101 66.4235 97.4243 66.7871 91.4849C67.1205 85.5758 46.6659 79.5758 39.0598 79.1212C31.4235 78.6667 24.9689 83.0909 24.6053 89C24.272 94.9697 30.1508 100.121 37.7871 100.545Z"
        fill="#242B2B"
      />
      <path
        d="M86.9379 90C88.8167 97.1515 84.5439 104.455 77.4227 106.333C70.2712 108.212 62.9682 103.97 61.0894 96.8182C59.2106 89.6667 63.4833 82.3636 70.6045 80.4848C77.7258 78.6061 85.0591 82.8485 86.9379 90Z"
        fill="#E5E8FF"
      />
    </svg>
  );
}
